import { PureComponent } from "react";

import QuoteComponent from "/components/core/boards-and-quotes-carousel/quote/quote-component";
import PictureComponent from "/components/core/picture/picture-component";

export default class BoardsCarouselItemComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { index, onClick } = this.props;
    onClick(index);
  }

  shouldRenderQuote() {
    const { item } = this.props;
    const { personImage, personTitle, quoteText } = item;
    return personImage || personTitle || quoteText;
  }

  render() {
    const { index, url, borderColor, item, aboveTheFold } = this.props;
    const { mobileImageWidthRatio } = item;
    const screenRatios = { mobile: mobileImageWidthRatio };
    const renderQuote = this.shouldRenderQuote();
    return (
      <div className="board-carousel-item-component board-carousel-item" key={index} onClick={this.onClick}>
        <div className="board-carousel-image-wrapper">
          <PictureComponent
            className="board-carousel-image"
            src={url}
            specificImageStyle={{ borderColor }}
            screenRatios={screenRatios}
          />
        </div>

        {renderQuote && <QuoteComponent activeQuote={item} aboveTheFold={aboveTheFold} />}
      </div>
    );
  }
}
